exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".common-dialog-content\n{\n  text-align: right;\n  direction: rtl;\n  max-height: 450px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/dialog-form/dialog-form.style.css
// module id = 896
// module chunks = 3